import { Header } from "../sections/header/header";
import { FAQItem } from "../sections/FAQItem";
import { faqColumns } from "../data/faqData";
import styles from "./faq.module.css";
import { Footer } from "../sections/footer/footer";

export const FAQPage = () => {
  const allFAQs = faqColumns.flat();

  return (
    <>
      <Header />
      <div className={styles.faqPage}>
        <div className={styles.container}>
          <h1 className={styles.pageTitle}>Veelgestelde vragen</h1>
          <div className={styles.faqGrid}>
            {allFAQs.map((faq, index) => (
              <FAQItem key={index} category={faq.category} question={faq.question} answer={faq.answer} />
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
